/** The build this screen is running, stamped in at build time (vite `define`). */
export const CLIENT_BUILD: string = typeof __BUILD__ === 'string' ? __BUILD__ : 'dev';
